import { DraggableFloatingModal } from '../floating-modal/DraggableFloatingModal';
import { LocationNotesContent } from './LocationNotesContent';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  locationId: string;
}

export function LocationNotesModal({ isOpen, onClose, locationId }: Props) {
  return (
    <DraggableFloatingModal
      isOpen={isOpen}
      onClose={onClose}
      title="Quick Notes"
    >
      <LocationNotesContent locationId={locationId} />
    </DraggableFloatingModal>
  );
}
